import { BaseEntity } from 'yt-ng-framework';
import { AngazovanjeRo } from './angazovanje-ro';

export class AnexRo extends AngazovanjeRo {
    constructor() {
        super();
    }

}
